exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btnSearch{width:54px;height:55px;background-color:transparent;margin-left:-55px;border:none;font-size:13px;line-height:54px;border-top-right-radius:5px;border-bottom-right-radius:5px;color:#666}", "", {"version":3,"sources":["/Users/telmo/Code/ahresp/taste-frontend/src/components/inputsearch/inputsearch.component.css"],"names":[],"mappings":"AAAA,WACI,WAAY,AACZ,YAAa,AACb,6BAA8B,AAC9B,kBAAmB,AACnB,YAAa,AACb,eAAgB,AAChB,iBAAkB,AAClB,4BAA6B,AAC7B,+BAAgC,AAChC,UAAe,CAClB","file":"inputsearch.component.css","sourcesContent":[".btnSearch{\n    width: 54px;\n    height: 55px;\n    background-color: transparent;\n    margin-left: -55px;\n    border: none;\n    font-size: 13px;\n    line-height: 54px;\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n    color: #666666;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/inputsearch/inputsearch.component.css
// module id = 831
// module chunks = 0